import { CSSProperties } from "react"

interface IIconProps {
    style?: CSSProperties
    onClick?: () => void
}

const InfoIcon = (props: IIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none" style={props.style} onClick={() => props.onClick && props.onClick()}>
            <path d="M8.00001 2.49219C4.46561 2.49219 1.60001 5.35779 1.60001 8.89219C1.60001 12.4266 4.46561 15.2922 8.00001 15.2922C11.5344 15.2922 14.4 12.4266 14.4 8.89219C14.4 5.35779 11.5344 2.49219 8.00001 2.49219ZM8.53334 12.0922H7.46667V8.35885H8.53334V12.0922ZM8.00001 7.02552C7.55841 7.02552 7.20001 6.66712 7.20001 6.22552C7.20001 5.78392 7.55841 5.42552 8.00001 5.42552C8.44161 5.42552 8.80001 5.78392 8.80001 6.22552C8.80001 6.66712 8.44161 7.02552 8.00001 7.02552Z" fill="#AEAEAE"/>
        </svg>
    )
}

export default InfoIcon
